import React, { useEffect } from "react";
import Header from "../../Components/Common/Header";
import Footer from "../../Components/Common/Footer";
import { connect } from "react-redux";
import InnerHeader from "../../Components/Common/InnerHeader";
import Login from "../../Components/Login/Login";

function ContactUs({ isLogin, Open }) {
  console.log(Open);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <div className="container">
      {Open && <Login />}
      <InnerHeader isLogin={isLogin} />
      <div className="ContactUsContainer">
        <span>
          آدرس شرکت: تهران ، خیابان سمیه ، بن بست پروین ، پلاک 2 ، طبقه اول
        </span>
        <span>تلفن: 02188846186</span>
        <span>ایمیل: info@mycontor.ir</span>
      </div>
      <Footer isLogin={isLogin} />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    Open: state.init.loginOpen,
    isLogin: state.auth.isLogin,
  };
};

export default connect(mapStateToProps)(ContactUs);
